export default __webpack_public_path__ + "static/media/ekahau.c6ab9be4.svg";